define('v3/Pages/Check/Components/CheckPupilGrid/Services/checkPupilGrid.Service',[
	'knockout',
	'jquery',
	'lodash',
	'v3/Pages/Check/Services/Check.Service',
	'v3/Pages/Check/Components/CheckPupilGrid/Services/checkPupilGrid.Backend',
	'v3/Common/Services/Backend/subjectGroupBackend',
	'v3/Pages/Check/Components/CheckPupilGrid/ViewModels/CheckPupil.ViewModel',
	'v3/Common/Services/Backend/extraInstructionBackend'
], function (
	ko,
	$,
	_,
	checkService,
	checkPupilBackend,
	subjectGroupBackend,
	CheckPupilViewModel,
	ExtraInstructionBackend
) {
	function CheckPupilGridService () {
		var self = this;

		self.getSubjectGroupsWithStatistics = function (pupilId, period, usePupilAverageGrowth) {
			var _pupilAbilityGrowthDeferred = getPupilAbilityGrowthDeferred(pupilId, period, usePupilAverageGrowth);
			var _subjectGroupSubjectCurrentPercentileDeferred = checkPupilBackend.getAllSubjectGroupsSubjectCurrentPercentilesForPupil(pupilId);
			var _subjectGroupTargetPercentileDeferred = checkPupilBackend.getUserSubjectGroupTargetPercentiles(pupilId);
			var _subjectGroupsDeferred = subjectGroupBackend.getPupilSubjectGroupsWhereEducationPlanExists(pupilId);

			return $.when(
				_subjectGroupsDeferred,
				_pupilAbilityGrowthDeferred,
				_subjectGroupSubjectCurrentPercentileDeferred,
				_subjectGroupTargetPercentileDeferred
			).then(function (subjectGroups,
				subjectGroupsAbilityGrowth,
				subjectGroupSubjectCurrentPercentilesModel,
				subjectGroupTargetPercentiles) {
				var checkPupilViewModels = _.map(subjectGroups, function (subjectGroup) {
					var checkPupilViewModel = new CheckPupilViewModel(
						subjectGroup,
						subjectGroupSubjectCurrentPercentilesModel[subjectGroup.id],
						subjectGroupTargetPercentiles[subjectGroup.id]);

					if (subjectGroupsAbilityGrowth) {
						var subjectGroupAbilityGrowth = usePupilAverageGrowth ? _.find(subjectGroupsAbilityGrowth, { 'subjectGroupId': subjectGroup.id })
							: subjectGroupsAbilityGrowth[subjectGroup.id];
						if (subjectGroupAbilityGrowth) {
							checkPupilViewModel.updateSubjectGroupAbilityGrowth(subjectGroupAbilityGrowth);
						}
					}

					checkPupilViewModel.selectedSubjectGroup.subscribe(function () {
						self.getSubdomains(checkPupilViewModel);
					});

					return checkPupilViewModel;
				});
				checkPupilViewModels = checkService.NormalizeAbilityGrowthInClass(checkPupilViewModels);
				return checkPupilViewModels;
			});
		};

		self.getSubjectGroupsWithAbilityGrowth = function (pupilId, period, usePupilAverageGrowth) {
			return getPupilAbilityGrowthDeferred(pupilId, period, usePupilAverageGrowth);
		};

		self.getSubdomainsBySubjectGroup = function (subjectGroupId) {
			return checkPupilBackend.getSubdomainsBySubjectGroup(subjectGroupId);
		};

		self.updateSubjectGroupAbilityGrowth = function (subjectGroupsArray, subjectGroupsAbilityGrowth, usePupilAverageGrowth) {
			_.forEach(subjectGroupsArray, function (checkPupilViewModel) {
				var growth = null;

				if (usePupilAverageGrowth) {
					growth = _.find(subjectGroupsAbilityGrowth, { 'subjectGroupId': checkPupilViewModel.subjectGroupId }) || { score: 0 };
				} else {
					growth = subjectGroupsAbilityGrowth[checkPupilViewModel.subjectGroupId] || { abilityGrowth: 0, targetAbilityGrowth: 0 };
				}

				checkPupilViewModel.updateSubjectGroupAbilityGrowth(growth);
			});
			checkService.NormalizeAbilityGrowthInClass(subjectGroupsArray);
		};

		self.getSubdomains = function (pupilVM) {
			if (pupilVM.hasData || pupilVM.isSubDomainsLoading()) {
				return;
			}

			pupilVM.isSubDomainsLoading(true);

			return $.when(
				checkPupilBackend.getSubdomainsBySubjectGroupWithBoundaryPercentileForPupil(
					pupilVM.subjectGroupId,
					pupilVM.selectedPupil.userId()
				),
				ExtraInstructionBackend.getNumberOfExtraInstructionsForSubdomains(
					pupilVM.subjectGroupId,
					pupilVM.selectedPupil.userId()
				)
			)
				.done(function (subdomains, extraInstructions) {
					_.each(subdomains, function (elm) {
						elm.selected = ko.observable(pupilVM.selectedSubjectGroup());
						elm.extraInstructions = ko.observable((extraInstructions[elm.subdomainId]) ? extraInstructions[elm.subdomainId] : false);
					});
					pupilVM.subDomains(subdomains);
					pupilVM.hasData = true;

					var oldSG = pupilVM.selectedSubjectGroup();
					ko.computed(function () {
						var selectedSG = pupilVM.selectedSubjectGroup();
						var selectedSD = _.filter(pupilVM.subDomains(), function (elm) {
							return elm.selected();
						});

						if (selectedSG !== oldSG) {
							_.each(pupilVM.subDomains(), function (elm) {
								elm.selected(selectedSG);
							});
						} else {
							if (selectedSD.length > 0 && selectedSD.length < subdomains.length && selectedSG !== 'mixed') {
								pupilVM.selectedSubjectGroup('mixed');
								selectedSG = 'mixed';
							} else if (selectedSD.length === subdomains.length && selectedSG !== true) {
								pupilVM.selectedSubjectGroup(true);
								selectedSG = true;
							}
						}

						oldSG = selectedSG;
					});
				})
				.always(function () {
					pupilVM.isSubDomainsLoading(false);
				});
		};

		self.generateReport = function (html) {
			return checkPupilBackend.generateReport(html);
		};

		function getPupilAbilityGrowthDeferred (pupilId, period, usePupilAverageGrowth) {
			if (usePupilAverageGrowth) {
				// whether the request to the Metrics API for getting data succeeds or fails the deferred
				// shouldn't be rejected but always return a valid result, so that the other calls that are being
				// made to retrieve data still continue
				var deferred = $.Deferred();

				checkPupilBackend
					.getAbilityGrowthForSubjectGroups(pupilId, period, usePupilAverageGrowth)
					.always(function (data, status) {
						var result = status === 'error' ? null : data;

						return deferred.resolve(result);
					});

				return deferred;
			} else {
				return checkPupilBackend.getAbilityGrowthForSubjectGroups(pupilId, period, usePupilAverageGrowth);
			}
		}
	}

	return new CheckPupilGridService();
});
